import { AccordionContent, AccordionTrigger } from "@/components/molecules/AccordionItem/accordion-item"
import { Accordion, AccordionItem } from "./accordion"
import { cn } from '@/utils/index'

export function AccordionSection({
  className,
  accordions,
  defaultValue,
}: {
  className?: string
  accordions: Record<string, React.ReactNode>
  defaultValue: string[]
}) {
  return (
    <Accordion type="multiple" className={cn("w-full", className)} defaultValue={defaultValue}>
      {Object.entries(accordions).map(([title, content]) => (
        <AccordionItem value={title} key={title}>
          <AccordionTrigger className="p-4 text-base font-bold">{title}</AccordionTrigger>
          <AccordionContent>{content}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
